import { HoverCard, HoverCardContent, HoverCardTrigger } from '@crowdex/ui/components/hover-card';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export function AnnotationChip({
  children,
  content,
  icon: Icon,
}: {
  children: ReactNode;
  content: ReactNode;
  icon: LucideIcon;
}) {
  return (
    <HoverCard openDelay={250}>
      <HoverCardTrigger asChild>
        <span className="type-ui inline-flex h-9 w-fit items-center gap-2 rounded-xl border border-hairline-strong bg-card px-2.5 text-xs shadow-sm">
          <span className="flex size-5 items-center justify-center rounded-md bg-background text-muted-foreground ring-1 ring-border/70 ring-inset">
            <Icon className="size-3" />
          </span>
          <span className="font-medium text-foreground/90">{children}</span>
        </span>
      </HoverCardTrigger>
      <HoverCardContent align="start" className="w-72 rounded-xl p-3" sideOffset={8}>
        {content}
      </HoverCardContent>
    </HoverCard>
  );
}
